import { ChangeDetectorRef, Component, ComponentFactoryResolver } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationListComponent, FilterListService } from 'gung-list';

@Component({
    selector: 'otto-olsen-pagination-list',
    templateUrl: './otto-olsen-pagination-list.component.html',
    styleUrls: ['./otto-olsen-pagination-list.component.scss'],
    standalone: false
})
export class OttoOlsenPaginationListComponent<T> extends PaginationListComponent<T> {



}
